import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from '../ui/label';
import { getAuthHeader } from '../../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL;

// Choix facultatif d'un rôle personnalisé dès la création du compte (Super Admin uniquement).
export const CustomRoleSelect = ({ value, onChange }) => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/roles/`, { headers: getAuthHeader() })
      .then(({ data }) => setRoles((data.roles || []).filter((r) => !r.is_system && r.is_active !== false)))
      .catch(() => setRoles([]));
  }, []);

  if (roles.length === 0) return null;
  return (
    <div className="space-y-1 rounded-lg bg-slate-50 p-4">
      <Label htmlFor="invitation-custom-role">Rôle personnalisé (facultatif)</Label>
      <select
        id="invitation-custom-role"
        data-testid="invitation-custom-role-select"
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm"
      >
        <option value="">Aucun — accès standard du type de compte</option>
        {roles.map((r) => <option key={r.name} value={r.name}>{r.display_name}</option>)}
      </select>
      <p className="text-xs text-slate-500">
        Administrateur : ses accès sont limités à ce rôle. Autre compte : ce rôle lui ouvre en plus les menus d’administration choisis.
      </p>
    </div>
  );
};
